import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { login } from "../../stores";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Col,
  Tab,
  Row,
} from "react-bootstrap";

function LoginPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");

  const [cardClasses, setCardClasses] = React.useState("card-hidden");

  React.useEffect(() => {
    setTimeout(function () {
      setCardClasses("");
    }, 1000);
  });

  // React.useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   if (token) {
  //     history.push("/dashboard");
  //   }
  // }, [history]);

  // const handlePrivacyLinkClick = () => {
  //   window.open("/privacy", "_blank", "noopener,noreferrer");
  // };
  return (
    <>
      <div
        className="full-page section-image"
        data-color="black"
        data-image={require("assets/img/full-screen-image-1.jpg").default}
      >
        <div className="content d-flex align-items-center p-0">
          <Container
            className="d-flex align-items-center justify-content-center"
            style={{ minHeight: "90vh" }}
          >
            <Col className="mx-auto" lg="4" md="7" sm="10">
              <Form
                action=""
                className="form"
                method=""
                onSubmit={(e) => {
                  e.preventDefault(); // Wajib agar halaman tidak reload
                  login(dispatch, { username, password }, history);
                }}
              >
                <Card
                  className="border-0 shadow-2xl"
                  style={{
                    borderRadius: "32px",
                    /* Gradasi Deep Ocean: Biru sangat gelap ke Biru Navy */
                    background:
                      "linear-gradient(145deg, #0f172a 0%, #1e293b 100%)",
                    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.6)",
                    overflow: "hidden",
                  }}
                >
                  <Card.Body className="p-5">
                    {/* Header Section */}
                    <div className="text-left mb-4">
                      <div
                        className="mb-4 d-flex align-items-center justify-content-center animate-float"
                        style={{
                          width: "60px",
                          height: "60px",
                          background:
                            "linear-gradient(135deg, #38bdf8 0%, #0ea5e9 100%)",
                          borderRadius: "18px",
                          boxShadow: "0 10px 20px rgba(14, 165, 233, 0.4)",
                        }}
                      >
                        <i
                          className="fas fa-sign-in-alt text-white"
                          style={{ fontSize: "22px" }}
                        ></i>
                      </div>
                      <h2
                        className="m-0 fw-900"
                        style={{
                          color: "#ffffff",
                          fontSize: "32px",
                          letterSpacing: "-1.5px",
                          fontWeight: "900",
                        }}
                      >
                        LOGIN
                      </h2>
                      <p
                        className="fw-500 mt-1"
                        style={{
                          fontSize: "14px",
                          color: "#94a3b8",
                          fontWeight: "500",
                        }}
                      >
                        Silakan masuk untuk akses portal BAP SMS.
                      </p>
                    </div>

                    {/* Form Section */}
                    <Form.Group className="mb-4">
                      <label
                        className="small text-uppercase mb-2 d-block"
                        style={{
                          letterSpacing: "1.5px",
                          fontSize: "11px",
                          fontWeight: "800",
                          color: "#38bdf8",
                        }}
                      >
                        NOPEG
                      </label>
                      <Form.Control
                        required
                        className="border-0 input-custom"
                        style={{
                          height: "55px",
                          backgroundColor: "rgba(255, 255, 255, 0.08)",
                          borderRadius: "16px",
                          paddingLeft: "20px",
                          fontSize: "15px",
                          fontWeight: "600",
                          color: "#FFFFFF", // Teks Putih
                          border: "1px solid rgba(255, 255, 255, 0.1)",
                        }}
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Masukkan Nopeg Anda"
                        type="text"
                      />
                    </Form.Group>

                    <Form.Group className="mb-5">
                      <label
                        className="small fw-800 text-uppercase mb-2 d-block"
                        style={{
                          letterSpacing: "1.5px",
                          fontSize: "11px",
                          fontWeight: "800",
                          color: "#38bdf8",
                        }}
                      >
                        PASSWORD
                      </label>
                      <Form.Control
                        required
                        className="border-0 input-custom"
                        style={{
                          height: "55px",
                          backgroundColor: "rgba(255, 255, 255, 0.08)",
                          borderRadius: "16px",
                          paddingLeft: "20px",
                          fontSize: "15px",
                          fontWeight: "600",
                          color: "#FFFFFF", // Teks Putih
                          border: "1px solid rgba(255, 255, 255, 0.1)",
                        }}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="••••••••"
                        type="password"
                      />
                    </Form.Group>

                    {/* Action Button */}
                    <Button
                      type="submit"
                      onClick={() =>
                        login(dispatch, { username, password }, history)
                      }
                      className="btn-block py-3 fw-800 border-0 mb-4 animate-press"
                      style={{
                        borderRadius: "16px",
                        background:
                          "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
                        color: "#ffffff",
                        fontSize: "15px",
                        letterSpacing: "1px",
                        fontWeight: "800",
                        boxShadow: "0 15px 30px rgba(2, 132, 199, 0.4)",
                        cursor: "pointer",
                      }}
                    >
                      SIGN IN
                    </Button>

                    {/* Footer */}
                    <div className="text-center pt-2">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ gap: "20px" }}
                      >
                        <a href="/auth/privacy" className="footer-link-blue">
                          Privacy Policy
                        </a>
                        <div
                          style={{
                            width: "4px",
                            height: "4px",
                            backgroundColor: "rgba(56, 189, 248, 0.4)",
                            borderRadius: "50%",
                          }}
                        ></div>
                        <a
                          href="/auth/termsandconditions"
                          className="footer-link-blue"
                        >
                          Terms & Conditions
                        </a>
                      </div>
                    </div>

                    <style>{`
  /* 1. Kondisi Normal (Glassmorphism Gelap) */
  .input-custom {
    color: #FFFFFF !important;
    caret-color: #FFFFFF !important;
    background-color: rgba(255, 255, 255, 0.08) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
  }

  /* 2. Kondisi SAAT DIKLIK (Focus) - Berubah jadi Putih Teks Hitam */
  .input-custom:focus {
    background-color: #FFFFFF !important; /* Background jadi putih solid */
    color: #1e293b !important;            /* Teks berubah jadi hitam slate */
    caret-color: #1e293b !important;        /* Garis kedip jadi hitam */
    border: 1px solid #0ea5e9 !important;
    box-shadow: 0 0 0 4px rgba(14, 165, 233, 0.3) !important;
    outline: none;
  }

  /* Menangani Autofill agar tetap sinkron saat dipilih */
  .input-custom:-webkit-autofill,
  .input-custom:-webkit-autofill:hover {
    -webkit-text-fill-color: #FFFFFF !important;
    -webkit-box-shadow: 0 0 0px 1000px #0f172a inset !important;
  }

  /* Saat Autofill SEDANG DIPILIH (Focus) */
  .input-custom:-webkit-autofill:focus {
    -webkit-text-fill-color: #1e293b !important;
    -webkit-box-shadow: 0 0 0px 1000px #FFFFFF inset !important;
  }

  .input-custom::placeholder {
    color: #94a3b8 !important;
    transition: all 0.3s;
  }

  /* Placeholder hilang/transparan saat focus agar bersih */
  .input-custom:focus::placeholder {
    opacity: 0;
  }
  
  .animate-float {
    animation: floating 3s ease-in-out infinite;
  }

  @keyframes floating {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-6px); }
  }

  .animate-press:active {
    transform: scale(0.98);
  }

  .footer-link-blue {
    color: #64748b;
    font-size: 12px;
    font-weight: 700;
    text-decoration: none;
  }

  .footer-link-blue:hover {
    color: #38bdf8 !important;
  }
`}</style>
                  </Card.Body>
                </Card>
              </Form>
            </Col>

            <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;800&display=swap');
    
    .container { font-family: 'Inter', sans-serif; }
    .fw-900 { font-weight: 900; }
    .fw-800 { font-weight: 800; }
    .fw-500 { font-weight: 500; }
    
    .form-control:focus {
      background-color: #f8fafc !important;
      box-shadow: 0 0 0 2px #1e293b !important;
    }

    .footer-link {
      color: #94a3b8;
      font-size: 12px;
      font-weight: 600;
      text-decoration: none;
      transition: color 0.2s;
    }
    .footer-link:hover { color: #1e293b; }

    .animate-press { transition: transform 0.1s, background-color 0.2s; cursor: pointer; }
    .animate-press:active { transform: scale(0.98); }
    .animate-press:hover { background-color: #0f172a !important; }

    @media (max-width: 576px) {
      .p-5 { padding: 2rem !important; }
      h2 { font-size: 26px !important; }
    }
  `}</style>
          </Container>
        </div>
        <div
          className="full-page-background"
          style={{
            backgroundImage:
              "url(" + require("assets/img/bgLogin.jpg").default + ")",
          }}
        ></div>
      </div>
    </>
  );
}

export default LoginPage;
